module.exports = __webpack_public_path__ + "home_bus2.fa3b2a7d0e7d8ea5e44e.png";


//////////////////
// WEBPACK FOOTER
// C:/Front-end/[PROYECTO] abordo-empresarial-cli4/[RAMA] actualizarAngular-Analytics/abordo-empresarial-cli4/src/assets/images/home_bus2.png
// module id = ../../../../../src/assets/images/home_bus2.png
// module chunks = 1